import React, { useState } from "react";
import "./cardteny.scss";
import { baseUrl } from "../../../config/config";
import { transformDate } from "../../../utils/date.formate";
import logo from "../../../assets/imgs/logo1.png";
import { Link } from "react-router-dom";
import { FaEllipsis } from "react-icons/fa6";

const CardTeny = ({ tenyzarainas, handleDelete }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const toggleMenuVisibility = () => {
    setIsMenuVisible(!isMenuVisible); // Inverser la visibilité du menu
  };

  return (
    <div className="card-tenyzaraina">
      <div className="entete">
        <div className="logo-entete">
          <img src={logo} alt="logo" />
          <div className="date">
            <span className="title">Teny Zaraina</span>
            <span className="date-publication">
              {transformDate(tenyzarainas.createdAt)}
            </span>
          </div>
        </div>
        <div className="menu">
          <FaEllipsis
            onClick={toggleMenuVisibility}
            style={{
              backgroundColor: "#dfe0e2",
              padding: "5px",
              borderRadius: "50%",
            }}
          />
          {isMenuVisible && (
            <div className="menu-options">
              <Link to={`/tenyzaraina/updateTenyzaraina/${tenyzarainas.id}`}>
                Modifier
              </Link>
              <span style={{ cursor: "pointer" }} onClick={handleDelete}>
                Supprimer
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="teny">
        <p>"{tenyzarainas.title}"</p>
        {isVisible ? (
          <>
            <p>{tenyzarainas.contenu}</p>
            <p>
              <strong>VAVAKA:</strong> {tenyzarainas.vavaka}
            </p>
            <p className="voir" onClick={toggleVisibility}>
              Voir moins...
            </p>
          </>
        ) : (
          <p className="voir" onClick={toggleVisibility}>
            Voir plus...
          </p>
        )}
        {tenyzarainas.file && !tenyzarainas.file.includes("mp4") && (
          <img
            src={`${baseUrl}/${tenyzarainas.file}`}
            alt={tenyzarainas.file}
          />
        )}
        {tenyzarainas.file && tenyzarainas.file.includes("mp4") && (
          <video width="500" height="500" controls>
            <source
              src={`${baseUrl}/tenyzaraina/stream/${tenyzarainas.id}`}
              type="video/mp4"
            />
          </video>
        )}
        {tenyzarainas.audio &&
          tenyzarainas.audio !== "undefined" &&
          tenyzarainas.audio.trim() !== "" && (
            <div className="audio-container">
              <audio controls className="audio">
                <source
                  src={`${baseUrl}/tenyzaraina/streamAudio/${tenyzarainas.id}`}
                  type="audio/mp3"
                />
              </audio>
            </div>
          )}
      </div>
      <div className="theme-teny">
        <p>{tenyzarainas.theme ? tenyzarainas.theme.nomTheme : null}</p>
      </div>
    </div>
  );
};

export default CardTeny;
